import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';

import { OralDeposition } from '../../../models/oral-deposition';

import { AddressService } from '../../../services/contacts/address.service';
import { NotyService } from '../../../services/common/noty.service';
import { OralDepositionService } from '../../../services/oral_depositions/oral-deposition.service';

@Component({
  selector: 'app-oral-deposition-form',
  templateUrl: './oral-deposition-form.component.html',
  styleUrls: ['./oral-deposition-form.component.scss'],
})
export class OralDepositionFormComponent implements OnInit {
  depositionAddresses: Array<any> = [];

  formOptions: any = {
    deponents: [],
    judges: [],
    participants: [],
  };

  formSubmitted: boolean = false;
  formSubmitting: boolean = false;

  loading: boolean = true;

  loadingDepositionAddresses: boolean = false;

  matter_id: number;

  oralDeposition: OralDeposition = new OralDeposition();

  oral_deposition_id: number;

  participantCount: number = 0;

  constructor(private addressService: AddressService, private location: Location, private notyService: NotyService, private oralDepositionService: OralDepositionService, private route: ActivatedRoute, private router: Router) {}

  // Component life cycle events
  ngOnInit() {
    this.matter_id = Number(this.route.snapshot.params['matter_id']);
    this.oral_deposition_id = Number(this.route.snapshot.params['id']);
    if (this.oral_deposition_id)
      this.oralDepositionService
        .edit(this.oral_deposition_id)
        .then((response_json) => {
          this.oralDeposition = response_json.oral_deposition;
          if (!this.matter_id) this.matter_id = this.oralDeposition.matter_id;
          this.oralDepositionService
            .formOptions(this.matter_id)
            .then((formOptions) => {
              this.loading = false;
              this.formOptions = formOptions;
              this.loadDepositionAddresses();
              for (let participant of this.oralDeposition.participants) for (let participant_form_option of this.formOptions.participants) if (participant.participant_id == participant_form_option.value) participant_form_option.checked = true;
              this.updateParticipantCount();
            })
            .catch(() => {
              this.loading = false;
            });
        })
        .catch(() => {
          this.loading = false;
        });
    else
      this.oralDepositionService
        .formOptions(this.matter_id)
        .then((formOptions) => {
          this.loading = false;
          this.formOptions = formOptions;
          this.oralDeposition.matter_id = this.matter_id;
          this.validateFormOptions();
        })
        .catch(() => {
          this.loading = false;
        });
  }

  // Component methods
  back() {
    this.location.back();
  }

  loadDepositionAddresses() {
    this.loadingDepositionAddresses = true;
    this.addressService
      .addressesByTypeName(this.oralDeposition.deponent_id, 'deposition')
      .then((depositionAddresses) => {
        this.loadingDepositionAddresses = false;
        this.depositionAddresses = depositionAddresses;
        if (depositionAddresses.length < 1) this.notyService.notify('No Deposition Addresses found', 'warning');
      })
      .catch(() => {
        this.loadingDepositionAddresses = false;
      });
  }

  saveOralDeposition(formValid: boolean) {
    this.formSubmitted = true;
    if (!formValid) {
      this.notyService.notify('Please check form', 'warning');
      return;
    }
    let selectedParticipants: Array<any> = [];
    for (let participant of this.formOptions.participants) if (participant.checked) selectedParticipants.push({ participant_id: participant.value });
    console.log(selectedParticipants);
    console.log(this.formOptions.participants);
    this.formSubmitting = true;
    this.oralDepositionService
      .save(this.oralDeposition, selectedParticipants)
      .then((response_json) => {
        this.formSubmitting = false;
        if (response_json.success) {
          this.notyService.notify(response_json.text || 'Oral deposition saved', 'success', 5000);
          this.router.navigateByUrl(`/oral_depositions/${response_json.oral_deposition_id}`);
        } else this.notyService.notify(response_json.text || 'Error saving oral deposition', 'error', 5000);
      })
      .catch(() => {
        this.formSubmitting = false;
        this.notyService.notify('Error saving oral deposition', 'error', 5000);
      });
  }

  updateParticipantCount() {
    this.participantCount = 0;
    for (let participant of this.formOptions.participants) if (participant.checked) this.participantCount += 1;
  }

  validateFormOptions() {
    let errors: Array<string> = [];
    if (this.formOptions.oral_deposition_present) errors.push(`An oral deposition for ${this.formOptions.deponent_name} is present in this matter. It will need to be either cancelled or finished before starting another request.`);
    if (!this.formOptions.lead_attorney_present) errors.push('No lead attorney assigned for this matter');
    if (!this.formOptions.deponents || this.formOptions.deponents.length < 1) errors.push('No deponents (clients) found for this matter');
    if (!this.formOptions.client_role) errors.push('No client role of plaintiff/defendant found for this matter');
    if (!this.formOptions.client_role) errors.push('No client role of plaintiff/defendant found for this matter');
    if (!this.formOptions.judges || this.formOptions.judges.length < 1) errors.push('No judges found for this matter');
    if (!this.formOptions.stenographers || this.formOptions.stenographers.length < 1) errors.push('No Stenographer contacts found for this matter');
    if (!this.formOptions.participants || this.formOptions.participants.length < 1) errors.push('No Defense Counsel contacts found for this matter');
    if (errors.length > 0) this.formOptions.errors = errors;
    else this.formOptions.errors = null;
  }
}
